module.exports = __webpack_public_path__ + "img/COWBOY HAT RED.c15bf81.svg";